module.exports = __webpack_public_path__ + "static/media/icon_area.026742fb.svg";